
var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};

jQuery('.original-selector').change(function(){
 jQuery('#custompricediv div').hide();
 setTimeout(function () {
   var varaintid = getUrlParameter('variant');
  // console.log(varaintid);
    jQuery("#custompricediv div").each(function(){
    var dataattr= jQuery(this).attr("data-variant-toggle");
      if (varaintid == dataattr){  
          jQuery(this).show();
      }
  });

}, 10);
});
  
